import _asyncToGenerator from "/Users/liuli/Documents/hu/riscern-pc-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/information/email.png';
import _imports_1 from '@/assets/information/pass.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-2f9b90ea"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "content"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "Account Information", -1);
});

var _hoisted_3 = {
  class: "account"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1);
});

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "Email", -1);
});

var _hoisted_6 = {
  class: "value"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1
  }, null, -1);
});

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", null, "Password"), /*#__PURE__*/_createElementVNode("div", {
    class: "value"
  }, "*******************")], -1);
});

var _hoisted_9 = [_hoisted_7, _hoisted_8];
import EmailDialog from './EmailDialog.vue';
import PassDialog from './PassDialog.vue';
import { emailVisible, passVisible } from './data.ts';
import { ref, onBeforeMount } from 'vue';
import { apiGetUser } from '@/api/login';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var userData = ref({});
    onBeforeMount( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$apiGetUser, data;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return apiGetUser();

            case 2:
              _yield$apiGetUser = _context.sent;
              data = _yield$apiGetUser.data;
              userData.value = data || {};

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    function onUpdateEmail() {
      emailVisible.value = true;
    }

    function onUpdatePass() {
      passVisible.value = true;
    }

    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", null, [_hoisted_5, _createElementVNode("div", _hoisted_6, _toDisplayString(userData.value.email), 1)])]), _createElementVNode("div", {
        class: "account account-active",
        onClick: onUpdatePass
      }, _hoisted_9), _createVNode(EmailDialog), _createVNode(PassDialog)]);
    };
  }
});